import styled from 'styled-components'
import React, { useCallback, useEffect, useState } from 'react'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import IconButton from 'components/Luxkit/Button/IconButton'
import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'
import LineCopyIcon from 'components/Luxkit/Icons/line/LineCopyIcon'
import useCopyToClipboard from 'hooks/useCopyToClipboard'
const PromoCodeContainer = styled.div`
  padding: 8px 16px;
  background-color: ${props => props.theme.palette.neutral.default.six};
  width: min-content;
  height: min-content;
`
function PromoCodeSection({ promoCode }:{promoCode: string}) {
  const [, copy] = useCopyToClipboard()
  const [isCopied, setIsCopied] = useState(false)

  const onClickCopyIcon = useCallback(() => {
    copy(promoCode)
    setIsCopied(true)
  }, [promoCode, copy])

  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => {
        setIsCopied(false)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [isCopied])

  return (
    <PromoCodeContainer>
      <Group direction="horizontal" gap={8} verticalAlign="center">
        <BodyText variant="medium" weight="bold">
          {promoCode}
        </BodyText>
        <IconButton
          kind="tertiary"
          size="small"
          shape="circle"
          onClick={onClickCopyIcon}
        >
          {isCopied ? <LineCheckIcon /> : <LineCopyIcon />}
        </IconButton>
      </Group>
    </PromoCodeContainer>
  )
}

export default PromoCodeSection
